import { getActiveTenantKey, getTenantScopedKey } from '../offline/tenant'
import { deleteKey } from './storage'

// v2.1 finding #60 (WSL-08, 2026-07-01): this module is a compile-error
// tripwire. Every consumer of the retired per-row sampling-aggregate sidecar
// has been migrated:
//   - Popover events -> server-backed `WeightSampleLog` via
//     `weightSampleLogApi.list` (WSL-05).
//   - Weight-cell badge counts -> daily rollup overlay from the same table
//     (WSL-06).
//   - Merge-planner arithmetic -> the pure module `samplingEventMath.ts`
//     (WSL-08).
// The ONLY surviving export is `clearSamplingAggregate`, called once per
// tenant during `ensureOfflineReady` bootstrap (via
// `src/offline/sidecarCleanup.ts`) to wipe residual legacy payloads from
// field-test devices. Nothing else should import from this file. The names
// `loadSamplingAggregateByRowId`, `saveSamplingAggregateByRowId`,
// `computeMeanWeightG`, `recordSamplingEvent`, `SamplingEvent`, and
// `SamplingAggregate` deliberately no longer exist here — any accidental
// re-introduction of the sidecar path will fail typecheck.

const STORAGE_KEY_BASE = 'production:samplingAggregate:v1'

const scopedKey = (tenantKey = getActiveTenantKey()): string => getTenantScopedKey(STORAGE_KEY_BASE, tenantKey)

/**
 * Delete the retired sidecar payload for the active tenant. Idempotent —
 * safe to call every bootstrap. Runs unconditionally: even devices that
 * never held sampling data get the deleteKey call, which is a no-op when
 * the key is absent.
 */
export const clearSamplingAggregate = (): void => {
  deleteKey(scopedKey())
}
